<template>
  <b-field :label="label">
    <qd-taginput
      v-model="selected"
      :icon="icon"
      :data="filtered"
      autocomplete
      :dropdown-position="dropdown"
      :type="type"
      :loading="isFetching"
      :field="field"
      :disabled="disabled"
      @typing="getFiltered">
      <template slot="empty">
        <div v-if="!isFetching">
          {{$t('general.autocomplete.noRslt')}}
        </div>
        <div v-else>{{$t('general.autocomplete.search')}}</div>
      </template>
    </qd-taginput>
  </b-field>
</template>

<script>
import debounce from 'lodash/debounce';
import messageErreur from '@/services/general/messageErreur';
import {
  TYPOLOGIE_POINT_DE_VENTE,
  TYPOLOGIE_ENSEIGNE,
  TYPOLOGIE_GROUPE, TYPOLOGIE_AUCUN,
} from '@/configuration/tiers/tiersConf';
import { getAll } from '@/api/tiers';

export default {
  name: 'queryTiersTagInput',
  data() {
    return {
      icon: 'magnify',
      type: 'is-primary',
      field: 'nomCommercial',
      isFetching: false,
      filtered: [],
      allTypologies: [
        TYPOLOGIE_POINT_DE_VENTE, TYPOLOGIE_ENSEIGNE,
        TYPOLOGIE_GROUPE, TYPOLOGIE_AUCUN,
      ],
    };
  },
  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      type: Array,
      required: true,
    },
    dropdown: {
      type: String,
      default: 'bottom',
    },
    typologie: {
      type: String,
      required: true,
    },
    societeActiveId: {
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    estLieuStockage: {
      type: Boolean,
      default: null,
    },
    sousTypes: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    selected: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      },
    },
  },
  methods: {
    getFiltered: debounce(async function getGroupes(search) {
      if (!search) return;
      this.isFetching = true;
      try {
        const items = (await getAll(
          {
            query: {
              auto: search,
              typologie: this.typologie === 'all' ? this.allTypologies : [this.typologie],
              societeId: this.societeActiveId,
              estLieuStockage: this.estLieuStockage,
              sousType: this.sousTypes,
            },
          },
        )).data.result.items;
        this.filtered = items.filter((item) => {
          return !this.selected.map(
            itemselected => itemselected.id,
          ).includes(item.id);
        });
        this.isFetching = false;
      } catch (e) {
        messageErreur(this.$i18n);
        throw (e);
      }
      this.isFetching = false;
    }, 300),
  },
};
</script>
